import React from 'react';

import { Box, Flex } from '@chakra-ui/react';
import PropTypes from 'prop-types';

/**
 * CenteredContent - A layout component for centering content in a full-viewport container.
 *
 * @description
 * This component should only be used on pages with no other content.
 * No left rail, header, or other content should be present when using this component.
 */
export const CenteredContent = ({ children, ...props }) => {
  return (
    <Flex width="100%" placeContent="center">
      <Box px={4} py={3} width="100%" maxW="1000px" {...props}>
        {children}
      </Box>
    </Flex>
  );
};

CenteredContent.propTypes = {
  children: PropTypes.node.isRequired,
  maxContentWidth: PropTypes.string,
  minHeight: PropTypes.string,
  bg: PropTypes.string,
  px: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
  py: PropTypes.oneOfType([PropTypes.number, PropTypes.string]),
};

export default CenteredContent;
